import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";

const EmployeeAttendance = ({ t }) => {
  const data = [
    { name: t("present"), value: 12, color: "#D1A855" },
    { name: t("absent"), value: 4, color: "#6B774A" },
    { name: t("vacation"), value: 2, color: "#3b82f6" },
    { name: t("task"), value: 1, color: "#ec4899" },
  ];

  return (
    <section className="border border-[#374151] rounded-2xl p-6 shadow-md mainLinear w-full">
      <h2 className="my-3 font-semibold ">{t("employeeAttendance")}</h2>
      <div className="flex items-center gap-4">
        <div className="w-40 h-40">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Tooltip formatter={(value, name) => [value, name]} />
              <Pie
                data={data}
                dataKey="value"
                innerRadius={50}
                outerRadius={75}
                paddingAngle={4}
                stroke="white"
                strokeWidth={2}
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        </div>
        <div className="space-y-3 text-right">
          {data.map((entry, index) => (
            <div
              key={index}
              className="flex items-center space-x-2 rtl:space-x-reverse"
            >
              <span
                className="block w-[6px] h-5 rounded"
                style={{ backgroundColor: entry.color }}
              />
              <span className="text-sm text-gray-300">
                {entry.name} ({entry.value})
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EmployeeAttendance;
